var map = {
	"./da.ts": [
		16477,
		"val-lang-da-ts"
	],
	"./de.ts": [
		89729,
		"val-lang-de-ts"
	],
	"./en.ts": [
		76373,
		"val-lang-en-ts"
	],
	"./es.ts": [
		4954,
		"val-lang-es-ts"
	],
	"./fa.ts": [
		5011,
		"val-lang-fa-ts"
	],
	"./fr.ts": [
		62926,
		"val-lang-fr-ts"
	],
	"./gr.ts": [
		35411,
		"val-lang-gr-ts"
	],
	"./hr.ts": [
		29328,
		"val-lang-hr-ts"
	],
	"./hu.ts": [
		97277,
		"val-lang-hu-ts"
	],
	"./it.ts": [
		42791,
		"val-lang-it-ts"
	],
	"./ja.ts": [
		73191,
		"val-lang-ja-ts"
	],
	"./jp.ts": [
		40328,
		"val-lang-jp-ts"
	],
	"./nl.ts": [
		78600,
		"val-lang-nl-ts"
	],
	"./pl.ts": [
		39302,
		"val-lang-pl-ts"
	],
	"./pt.ts": [
		85278,
		"val-lang-pt-ts"
	],
	"./ro.ts": [
		87205,
		"val-lang-ro-ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 99920;
module.exports = webpackAsyncContext;